<svelte:options runes={false} />

<script>
  import { minorToMoney } from '../../api/invoices';
  import StatRow from './StatRow.svelte';

  export let currency;
  export let suggestedTotalMinor;
  export let showCurrentContribution = false;
  export let currentTotalMinor = 0;
</script>

<section class="totals reference-quote" aria-label="Suggested contribution">
  <StatRow grand label="Operator suggestion" value={minorToMoney(suggestedTotalMinor, currency)} />
  {#if showCurrentContribution}
    <StatRow grand label="Your current contribution" value={minorToMoney(currentTotalMinor, currency)} />
  {/if}
  <p class="quiet">
    That's every reported hour at the asking rate — a reference, not a bill. You
    can pay for some of the work or all of it, at the ask or at your own rate.
  </p>
</section>
